module.exports = __webpack_public_path__ + "img/operation3.4a3583f4.png";